import { createContext, useContext } from "react"
import CandleChangeManager from "./candleChangeManager"

interface CandleChangeManagerContextProps {
  manager: CandleChangeManager | undefined;
}

export const CandleChangeManagerContext = createContext<CandleChangeManagerContextProps>({
  manager: undefined,
});

export const useCandleChangeManager = () => useContext(CandleChangeManagerContext);
